import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { formatNumber } from "@/shared/utils/Numbers.tsx";

export default function useFormatDurationMinutes(): (
  minutes: number,
  short?: boolean,
) => string {
  const { t } = useTranslation("common");
  return useCallback(
    (minutes: number, short = false) => {
      const minutesAbs = Math.abs(minutes);
      const sign = minutes < 0 ? "-" : "";
      const h = Math.floor(minutesAbs / 60);
      const m = Math.floor(minutesAbs % 60);
      if (h === 0 && short) {
        return `${sign}${m}'`;
      }
      let res = `${sign}${formatNumber(t, h, 0)}h`;
      if (m > 0) {
        res += `${m}`.padStart(2, "0");
      }
      return res;
    },
    [t],
  );
}
